// lhdnLogsApi.js
import axios from 'axios';

const lhdnLogsApi = {
  // Fetch LHDN API logs with optional filters and pagination
  async fetchLogs(params = {}, url = null) {
    const config = {
      headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
    };
    
    if (url) {
      // For pagination URLs, don't include params as they're already in the URL
      return await axios.get(url, config);
    } else {
      // For initial fetch or filtered requests
      config.params = params;
      return await axios.get('/api/v1/lhdnvalidation/lhdn-validation/', config);
    }
  },

  // Download LHDN logs as CSV
  async downloadLogsCSV(params = {}) {
    const config = {
      headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
      params: { ...params, format: 'csv' },
      responseType: 'blob',
    };
    
    return await axios.get('/api/v1/lhdnvalidation/lhdn-validation/', config);
  },

  // Get a specific LHDN log entry by ID
  async getLogEntry(id) {
    const config = {
      headers: { 'Authorization': `Token ${localStorage.getItem('token')}` },
    };
    
    return await axios.get(`/api/v1/lhdnvalidation/lhdn-validation/${id}/`, config);
  },

  // Helper method to create download link for CSV
  downloadCSVFile(data, filename = null) {
    const defaultFilename = `lhdn_api_logs_${new Date().toISOString().split('T')[0]}.csv`;
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename || defaultFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

export default lhdnLogsApi;
